import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import { TypeInscricaoDoAlunoNaViagem } from "@/Models/Domain/Viagem/InscricaoDoAlunoNaViagem";
import { Button, ButtonProps, Form, notification, Popconfirm, PopconfirmProps, Typography } from "antd";
import { createRef, useRef } from "react";
import GerarLinkPagamentoForm from "./GerarLinkPagamentoForm";
import { useGerarLinkPagamentoInscricao } from "@/Services/Domain/Viagem/InscricaoService";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { IGerarLinkPagamentoInscricaoParamsFormType } from "./GerarLinkPagamentoFormBasic";
import { useTituloGerarLink } from "@/Services/Financeiro/Titulo/TituloService";

export interface IGerarLinkPagamentoFormPopConfirmProps extends Partial<IModalBaseProps> {
    inscricao : TypeInscricaoDoAlunoNaViagem;
}
export default function GerarLinkPagamentoFormPopConfirm({
    title,
    textButtonOpen,
    propsButtonOpen,
    width,
    destroyOnClose,
    ...rest
}: IGerarLinkPagamentoFormPopConfirmProps) {
    const refModal = useRef<ModalBaseRefType|null>(null);
    const [form] = Form.useForm<IGerarLinkPagamentoInscricaoParamsFormType>();
    const refCopy = createRef<HTMLSpanElement>();
    
    const {
        isPending,
        mutate
    } = useGerarLinkPagamentoInscricao({
        onSuccess(data, variables, context) {
            if (form.getFieldValue("enviaEmail") === false)
            {
                form.setFieldValue("codTitulo", data?.data?.titulo?.codigo ?? undefined);
                /// @ts-ignore
                refCopy.current?.querySelector?.('.ant-typography-copy')?.click?.();
            }
            else 
            {
                refModal.current?.fechar?.();
            }

            notification.success(PropriedadesDeNotificacao.Sucesso("Pagamento gerado com sucesso."));
        }
    });

    

    const {
        mutateAsync : gerarLinkAsync
    } = useTituloGerarLink({
        onSuccess(data, variables, context) {
            refModal.current?.fechar?.();
        }
    });

    return <ModalBase
        {...rest}
        ref={refModal}
        title={title ?? "Gerar link de pagamento"}
        textButtonOpen={textButtonOpen ?? "Gerar link"}
        propsButtonOpen={propsButtonOpen ?? {
            size: "middle"
        } as ButtonProps}
        width={width}
        destroyOnClose={destroyOnClose ?? true}
        confirmLoading={isPending}
        footer={[
            <Button
                key="cancelar"
                size="small"
                danger
                onClick={() => refModal.current?.fechar?.()}
                loading={isPending}
            >Cancelar</Button>,
            <Button 
                key="copiar-link-pagamento"
                size="small"
                type="dashed"
                onClick={() => {
                    form.setFieldValue("enviaEmail", false);
                    form.submit();
                }}
            >
                <Typography.Text 
                    ref={refCopy} 
                    copyable={{
                        tooltips : false,          
                        text : () => gerarLinkAsync(form.getFieldValue("codTitulo")!).then(resp => `${window.location.origin}/Financeiro/Pagamento?${resp.data}`)
                    }}>Salvar e copiar</Typography.Text>
            </Button>,
            <Button
                key="gerar-e-enviar-email"
                type="primary"
                size="small"
                onClick={() => {
                    form.setFieldValue("enviaEmail", true);
                    form.submit();
                }}
                loading={isPending}
            >Salvar e enviar cobrança</Button>
        ]}
    >
        <GerarLinkPagamentoForm  
            form={form}
            onFinish={(values) => mutate(values)}
            codInscricao={rest.inscricao.codigo!}
        />
    </ModalBase>;
}